import { useContext, useEffect } from "react";

import { 
    LoadSavedQuotationsCard, 
    QuotationInfoContext,
    QuotationStep,
} from "../../../shared";
import { LOADING_RENEWAL_QUOTATION_STATES } from "../../../shared/interfaces/loading-renewal-quotation-states-enum";

const {
    INIT_LOADING_RENEWAL,
    STEP_THREE_DATA_FILLED_RENEWAL,
    FINISH_LOADING_RENEWAL,
} = LOADING_RENEWAL_QUOTATION_STATES;

export const RenewalCarQuotation = () => {
    const { 
        renewalQuotationState,
        setRenewalQuotationState,
        setLoadingRenewalQuotation,
        setCurrentStep,
    } = useContext(QuotationInfoContext);

    useEffect(() => {
        if(renewalQuotationState === STEP_THREE_DATA_FILLED_RENEWAL) {
            setRenewalQuotationState(FINISH_LOADING_RENEWAL);
            setLoadingRenewalQuotation(false);
            setCurrentStep(QuotationStep.THREE);
        };
    }, [renewalQuotationState]);

    useEffect(() => {
        setRenewalQuotationState(INIT_LOADING_RENEWAL);
        /* eslint-disable-next-line */
    }, []);

    return <LoadSavedQuotationsCard />;
};
